import React, { useState } from 'react';
import { Message } from '@bijie/react-bnb';
import EmailVerify from '../EmailVerify';
import API_PATH from '../../actions/actionsFactory/apiPath';
import { gwPost } from '../../actions/actionsFactory/gwRequest';
import { setPostBody } from '../../actions/actionsFactory';

type Props = {
  title: string,
  desc: string,
  onCountDownEnd?: Function,
  cutDownTime?: number,
};

export default ({
  title,
  desc,
  onCountDownEnd,
  cutDownTime = 300,
}: Props) => {
  const [sending, setSending] = useState(false);
  const resendEmail = async (geetestParams) => {
    const params = setPostBody({
      ...geetestParams,
    });
    try {
      setSending(true);
      const result = await gwPost(API_PATH.RESEND_EMAIL_FOR_RESET, { params }, null, false);
      if (result.success) {
        Message.success('success', 3);
      } else {
        Message.fail(result.message, 3);
        setSending(false);
      }
    } catch (error) {
      setSending(false);
      throw error;
    }
  };
  const handleCountDownEnd = () => {
    setSending(false);
    if (onCountDownEnd) {
      onCountDownEnd();
    }
  };
  return (
    <EmailVerify
      title={title}
      desc={desc}
      sending={sending}
      resendEmail={resendEmail}
      onCountDownEnd={handleCountDownEnd}
      cutDownTime={cutDownTime}
    />
  );
};
